/**
 * Полный каталог тем (WEB-3447, заход 3, решение владельца 17.10 ~07:58).
 *
 * ЗАЧЕМ. Тема «Blue Gradient» (эталон Slimkit, WEB-3128) несёт градиенты
 * бренда, а их рисует ленивый кусок плеера: в первом экране покупателя её
 * описание — лишний вес. Поэтому:
 *  - `EAGER_THEMES` (presets.ts) — темы первого экрана;
 *  - `LAZY_THEMES` — темы, что едут в куске (`STYLE_KIT.lazyThemes`), их
 *    имена первый экран знает по `LAZY_THEME_IDS` (styleKitDoor.ts) и ждёт
 *    кусок до первого кадра;
 *  - `THEMES` — всё вместе: галерея кабинета, сторожа контраста и сверки
 *    имён с сервером.
 * Этот файл первый экран статически НЕ тянет (сторож сборки
 * FIRST_SCREEN_DEFERRED_MODULES). Сверка двух концов — themeCatalog.test.ts.
 */
import type { Theme } from './theme.types';
import { EAGER_THEMES } from './presets';

export const LAZY_THEMES: Theme[] = [
  {
    // WEB-3128 (перенос Slimkit): тема эталона — анкета Slimkit, светлая.
    // Источник цветов: slimkit-research/spec/tokens/tokens.json. Шрифт воронки
    // задаёт settings.fontId: 'system' (решение №1), стек ниже — запасной.
    id: 'blue-gradient-light',
    name: 'Blue Gradient',
    category: 'fitness',
    colors: {
      primary: '#155dfc', // конец градиента кнопки / выбранного
      primaryHover: '#2b7fff', // начало градиента кнопки
      background: '#ffffff',
      surface: '#f6f8fa', // фон карточки варианта
      textPrimary: '#030303',
      textSecondary: '#7b7991',
      border: '#d9d9d9',
      success: '#00c950', // зелёный пейволла эталона
      danger: '#ff416e', // высокий ИМТ
      accent: '#2966ff', // акцентные слова в заголовках, ссылки
      onPrimary: '#ffffff',
    },
    // Решение №2: роли градиента бренда → --gradient-selected / --gradient-button /
    // --gradient-progress (themes/gradient.ts). Градиент пройденного узла
    // прогресса (progressNode) приходит с диффом 5 (группа 2 переноса).
    gradients: {
      selected: 'linear-gradient(14deg, #1155ec 27.31%, #2777f2 160.52%)',
      button: 'linear-gradient(135deg, #2b7fff 0%, #155dfc 100%)',
      progress: 'linear-gradient(270deg, #008cff 0%, #005fff 100%)',
    },
    typography: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      fontSizeBase: 16,
      fontWeightHeading: 700,
    },
    radius: { sm: 12, md: 16, lg: 16, button: 40 },
    buttonStyle: 'gradient',
    backgroundStyle: { type: 'solid' },
  },
];

export const THEMES: Theme[] = [...EAGER_THEMES, ...LAZY_THEMES];
